module.exports = __webpack_public_path__ + "img/SiqiLi.73324767.jpg";